import classNames from "classnames";
import styles from "./index.module.scss";

type PropsType = {
  userRole: string;
};

const RoleLabel = ({ userRole }: PropsType) => {
  const userRoleLabel = (() => {
    if (userRole === "Sales Rep") return "Motion Team";
    if (userRole === "Administrator" || userRole === "Location Admin")
      return "Admin";
    return userRole;
  })();
  return (
    <span
      className={classNames(styles.box, styles.default, {
        [styles.authorizer]: userRole === "Authorizer" || userRole === "Motion Support",
        [styles.salesRep]: userRole === "Sales Rep",
        [styles.admin]:
          userRole === "Administrator" || userRole === "Location Admin",
      })}
    >
      {userRoleLabel}
    </span>
  );
};

export default RoleLabel;
